var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHlpFeatureRequest(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 14,
    viewBox: "0 0 18 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.99996 7.8335H11.5V6.16683H3.99996V7.8335ZM3.99996 5.3335H11.5V3.66683H3.99996V5.3335ZM2.33329 13.6668C1.87496 13.6668 1.48274 13.5038 1.15663 13.1777C0.829959 12.851 0.666626 12.4585 0.666626 12.0002V2.00016C0.666626 1.54183 0.829959 1.14961 1.15663 0.823496C1.48274 0.496829 1.87496 0.333496 2.33329 0.333496H15.6666C16.125 0.333496 16.5175 0.496829 16.8441 0.823496C17.1702 1.14961 17.3333 1.54183 17.3333 2.00016V12.0002C17.3333 12.4585 17.1702 12.851 16.8441 13.1777C16.5175 13.5038 16.125 13.6668 15.6666 13.6668H2.33329ZM2.33329 12.0002H15.6666V2.00016H2.33329V12.0002ZM2.33329 12.0002V2.00016V12.0002Z",
    fill: "#5F488A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHlpFeatureRequest);
export default __webpack_public_path__ + "static/media/hlp_featureRequest.972488c98226bd9212e26ddd7b16ca0e.svg";
export { ForwardRef as ReactComponent };